import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";
import tw from "twin.macro";

import { renderTab } from "@/components/NavigationTabs";
import { PageContent } from "@/components/page";
import { useClientContext } from "@/data-loaders/client-data-loader";
import { useAreaContext } from "@/hooks/useAreaContext";
import { usePostDetailContext } from "@/hooks/usePostDetailContext";

import { useClientUIContext } from "./useClientBreadcrumb";

const PostDetailsTabs = ({
  tabs,
  currentPath,
}: {
  tabs: { name: string; to: string }[];
  currentPath: string;
}) => (
  <nav css={tw`w-fit flex border-b`}>
    {tabs.map((tab) => renderTab(tab, currentPath))}
  </nav>
);

export const PostDetailsLayout = () => {
  const { t } = useTranslation();
  const { post } = usePostDetailContext();
  const { area } = useAreaContext();
  const client = useClientContext();
  const { setBreadcrumbItems, defaultItems, setShowClientTabs, setPageTitle } =
    useClientUIContext();

  let { pathname } = useLocation();
  pathname = pathname.split("/").pop() as string;
  const isPathRoot = pathname === post.address.toString();
  pathname = isPathRoot ? "." : pathname;

  const sectionsTabs = [
    { name: "Maintenance", to: "." },
    { name: "Monitoring", to: "monitoring" },
    { name: "Historique", to: "history" },
  ];

  useEffect(() => {
    setBreadcrumbItems([
      ...defaultItems,
      { to: `/clients/${client._id}/areas/#${area._id}`, children: area.name },
    ]);
    setPageTitle(`${t("postDetails.pantograph")} ${post.address}`);
    setShowClientTabs(false);

    return () => {
      setBreadcrumbItems(defaultItems);
      setPageTitle(client.name);
      setShowClientTabs(true);
    };
  }, [setShowClientTabs, setPageTitle, setBreadcrumbItems, defaultItems]);

  return (
    <PageContent tw="max-w-7xl pt-4">
      <div tw="flex flex-col gap-8 z-10">
        <div tw="flex flex-col gap-6">
          <div tw="flex flex-col items-start max-w-md gap-2 bg-white shadow rounded-xl p-4">
            <div tw="text-gray-700">
              <span tw="font-semibold">Adresse Wirepas</span> : {post.address}
            </div>
            <div tw="text-gray-700">
              <span tw="font-semibold">Gateways</span> :{" "}
              {area.gateways.map((gateway) => gateway.name).join(", ")}
            </div>
            {post.latitude && post.longitude && (
              <div tw="text-gray-700">
                <span tw="font-semibold">GPS</span> :{" "}
                <span tw="font-normal">{post.latitude}</span>,{" "}
                <span tw="font-normal">{post.longitude}</span>
                {post.longitude}
              </div>
            )}
          </div>

          <PostDetailsTabs tabs={sectionsTabs} currentPath={pathname} />

          <Outlet />
        </div>
      </div>
    </PageContent>
  );
};
